/* global document */
import addHours from 'date-fns/addHours';

import { ILMOffice, ILMProvider } from '../../types';
import { formatFullAddress } from './formatAddress';
import { toDateNonNullable } from './toDate';

interface Props {
  patientName?: string;
  provider?: ILMProvider | null;
  office?: ILMOffice | null;
  topic: string;
  id: string;
  time: Date;
}

export default function getCalendarEvent({
  patientName,
  provider,
  office,
  topic,
  id,
  time,
}: Props) {
  const calendarEventTitle = provider
    ? `${patientName}’s Appointment with ${provider.display}`
    : `${patientName}’s Appointment`;

  return {
    uid: `${topic}-${id}`,
    url: typeof document !== 'undefined' ? document.location.href : null,
    title: calendarEventTitle,
    startTime: time,
    // We do not have a duration for the appointment, but it's required to
    // create calendar events. So we use a pretty standard amount of 1 hour.
    endTime: addHours(toDateNonNullable(time), 1),
    status: 'CONFIRMED',
    location: office ? formatFullAddress(office) : null,
    latitude: office?.latitude,
    longitude: office?.longitude,
  };
}
